import wrapWithProvider from './src/wrap-with-provider';

require('@konrady/ui-components/fonts/index.css');

export const wrapRootElement = wrapWithProvider;
